import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.element.addEventListener("turbo:submit-start", this.disableFormElements)
    }

    disconnect() {
        this.element.removeEventListener("turbo:submit-start", this.disableFormElements)
    }

    disableFormElements = (event) => {
        for (const field of event.target.elements) {
            if (field.type !== 'submit' && field.type !== 'button') {
                field.disabled = true;
            }
        }
    }
}
